import React from 'react';
import Note from './Note';

export default function Board({ notes, onDelete, onUpdate }) {
  if (!notes.length) {
    return <div className="empty">No notes yet. Add one above!</div>;
  }

  return (
    <div className="board">
      {notes.map((n) => (
        <Note key={n.id} note={n} onDelete={onDelete} onUpdate={onUpdate} />
      ))}
    </div>
  );
}
